// eslint-disable-next-line no-shadow
export enum SpaceInfoTabs {
  INDEX = 'index',
  MEMBERS = 'members',
  EDIT = 'edit',
}
